export default class InvestorsController {
    constructor($state, $ionicScrollDelegate, $stateParams) {
        this.$state = $state;
        this.investorType = $stateParams.defaultTab;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
        this.disabledx = false;
        this.filterIndicationText = '';
    }

    init() {
        this.sortOrder = {
            value: 'AUM_DESC',
            field: 'AUM',
            order: 'DESC',
            type: 'AUM',
        };
        this.sortCriteria = [
            { value: 'AUM_DESC', field: 'AUM', order: 'DESC', type: 'AUM' },
            { value: 'AUM_ASC', field: 'AUM', order: 'ASC', type: 'AUM' },
            { value: 'NAME_DESC', field: 'NAME', order: 'ASC', type: 'NAME' },
            { value: 'NAME_ASC', field: 'NAME', order: 'DESC', type: 'NAME' },
            {
                value: 'COUNTRY_ASC',
                field: 'COUNTRY',
                order: 'ASC',
                type: 'COUNTRY',
            },
            {
                value: 'COUNTRY_DESC',
                field: 'COUNTRY',
                order: 'DESC',
                type: 'COUNTRY',
            },
        ];

        this.updateDisable = (flag) => {
            this.disabled = flag;
        };
    }

    isFilterActive() {
        return (
            this.filterIndicationText && this.filterIndicationText.length > 0
        );
    }

    onTabChange(type) {
        this.investorType = type;
        this.$ionicScrollDelegate.scrollTop();
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/investors/investors.controller.js
 **/